import React, { useEffect, createElement } from 'react';
import { CONTACT } from '../lib/constants';
/** Sets document title, meta description and injects Organisation + FAQ JSON-LD using supplied facts only. */
export function SeoHead() {
  useEffect(() => {
    document.title = 'Managed IT Services for Professional Firms | CT Group';
    const setMeta = (name: string, content: string) => {
      let el = document.querySelector<HTMLMetaElement>(`meta[name="${name}"]`);
      if (!el) {
        el = document.createElement('meta');
        el.setAttribute('name', name);
        document.head.appendChild(el);
      }
      el.setAttribute('content', content);
    };
    setMeta('description', 'End-to-end managed IT, security, hosting and voice for Australian law, accounting and professional services firms. Start with an independent IT Review.');
    const org = {
      '@context': 'https://schema.org',
      '@type': 'Organization',
      name: 'CT Group',
      description: 'End-to-end managed IT for professional services firms — managed services, security, hosting and voice.',
      telephone: CONTACT.phone,
      email: CONTACT.email,
      areaServed: ['Perth', 'Melbourne', 'Sydney', 'Brisbane', 'Australia'],
      employee: [{
        '@type': 'Person',
        name: CONTACT.ceo,
        jobTitle: 'CEO'
      }, {
        '@type': 'Person',
        name: CONTACT.growthName,
        jobTitle: 'Head of Growth',
        email: CONTACT.growthEmail
      }]
    };
    const faq = {
      '@context': 'https://schema.org',
      '@type': 'FAQPage',
      mainEntity: [{
        '@type': 'Question',
        name: 'What does an end-to-end managed IT partner manage?',
        acceptedAnswer: {
          '@type': 'Answer',
          text: 'CT Group manages the full technology environment your people use each day: infrastructure, software, licensing, users, support, security, hosting and voice, coordinated as one connected system.'
        }
      }, {
        '@type': 'Question',
        name: 'What is included in the Independent IT Review?',
        acceptedAnswer: {
          '@type': 'Answer',
          text: 'The review examines your support model and responsibility map, security posture and Essential Eight considerations, hosting, backup and continuity dependencies, and software, licensing and vendor responsibilities, with prioritised recommendations in plain English.'
        }
      }, {
        '@type': 'Question',
        name: 'Do we need to change providers to complete the review?',
        acceptedAnswer: {
          '@type': 'Answer',
          text: 'No. The Independent IT Review is a practical, non-intrusive exercise designed to give you clarity, not to force a switch. You retain full decision control.'
        }
      }, {
        '@type': 'Question',
        name: 'Which locations does CT Group support?',
        acceptedAnswer: {
          '@type': 'Answer',
          text: 'CT Group was established in Perth and supports professional firms across Australia, including Melbourne, Sydney and Brisbane, with a growing east-coast presence.'
        }
      }]
    };
    const inject = (id: string, data: object) => {
      let s = document.getElementById(id) as HTMLScriptElement | null;
      if (!s) {
        s = document.createElement('script');
        s.id = id;
        s.type = 'application/ld+json';
        document.head.appendChild(s);
      }
      s.textContent = JSON.stringify(data);
    };
    inject('ld-org', org);
    inject('ld-faq', faq);
  }, []);
  return null;
}